module.exports = "<div class=\"icon-container\" ng-style=\"{'background-image': 'url('+$ctrl.iconUrl+')'}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./modules/distribution/directives/jf-page-title/page.title.icon.view.html
// module id = 481
// module chunks = 7